import { render, staticRenderFns } from "./footerQuestions.vue?vue&type=template&id=60e0e8fa&scoped=true"
import script from "./footerQuestions.vue?vue&type=script&lang=js"
export * from "./footerQuestions.vue?vue&type=script&lang=js"
import style0 from "./footerQuestions.vue?vue&type=style&index=0&id=60e0e8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0e8fa",
  null
  
)

export default component.exports